// extracted by mini-css-extract-plugin
export default {"container":"_34nZHvG59KieZYnAcWi4xS","icon":"_3aIE134Xb_bd-A5cZkdZv6","text":"sHzyzs0VpO9Kq0o37jnrK"};